export default [
  {
    path: '/admin/priceconfig',
    name: 'AdminPriceConfig',
    component: () => import('./PriceConfigPage.vue'),
    meta: {
      requiresAuth: false,
      headerColor: 'white'
    }
  }
];
